import { render, staticRenderFns } from "./DatatableHome.vue?vue&type=template&id=6c9aa208&"
import script from "./DatatableHome.vue?vue&type=script&lang=js&"
export * from "./DatatableHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports